$(document).ready(function () {
    var site_type = $('#site_type').val();
    var class_name = 'icheckbox_minimal-green';
    if(site_type === 'hirebee'){
        class_name = 'icheckbox_minimal-blue';
    }
    $('.add_video_check').iCheck({
        checkboxClass: class_name,
        radioClass: 'iradio_minimal',
        increaseArea: '20%'
    });

    $('.add_video_check').on('ifChecked', function () {
        $('.video_url_block').removeClass('no_display');
    });

    $('.add_video_check').on('ifUnchecked', function () {
        $('#users-video_url').val('');
        $('.video_url_block').addClass('no_display');
    });
})